import { Link, useLocation } from "react-router-dom";
import { Scale } from "lucide-react";

export default function NavBar() {
  const { pathname } = useLocation();
  const linkCls = (active) =>
    `text-sm tracking-wide transition-colors ${
      active ? "text-accent" : "text-primary hover:text-accent"
    }`;
  return (
    <header
      className="sticky top-0 z-30 bg-background/85 backdrop-blur border-b border-border"
      data-testid="navbar"
    >
      <div className="max-w-6xl mx-auto px-6 md:px-10 h-14 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2.5" data-testid="nav-logo">
          <Scale className="h-5 w-5 text-accent" strokeWidth={1.6} />
          <span className="font-serif text-xl text-primary leading-none">
            Pergunte ao <span className="italic text-accent">Dr.</span>
          </span>
        </Link>
        <nav className="flex items-center gap-6">
          <Link to="/" className={linkCls(pathname === "/")} data-testid="nav-home">
            Início
          </Link>
          <Link
            to="/sobre"
            className={linkCls(pathname.startsWith("/sobre"))}
            data-testid="nav-about"
          >
            Sobre o Dr. Edson
          </Link>
          <Link
            to="/juros-abusivos-nao"
            className={linkCls(pathname.startsWith("/juros-abusivos"))}
            data-testid="nav-juros-abusivos"
          >
            Juros Abusivos
          </Link>
        </nav>
      </div>
    </header>
  );
}
